import { useEffect } from "react";
import { genieContext } from "./registries/context-registry";
import { useIsGenieEnabled } from "./useIsGenieEnabled";

export function useGenieContext(
  key: string,
  description: string,
  value: unknown,
  extraEnabled = true
) {
  const enabled = useIsGenieEnabled() && extraEnabled;
  useEffect(() => {
    if (!enabled) return;
    return genieContext.set(key, description, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, description, enabled ? JSON.stringify(value) : null, enabled]);
}
